import React, { useState, useEffect } from "react";
import { t } from "../../../../utils/i18n";
import Cards from "react-credit-cards-2";
import { getRequest } from "../../../../utils/httpRequest";
import "./index.scss";
import "react-credit-cards-2/dist/es/styles-compiled.css";
import { HideIcon, ShowIconEye } from "../../../Dashboard/dashboardIcons";

const DebitCard = ({
  currentUser,
  cardId,
  canActivateCard,
  cardBalance: propCardBalance,
}) => {
  const [showModal, setShowModal] = useState(false);
  const [message, setMessage] = useState("");
  const [cardBalance, setCardBalance] = useState(0);
  const [showBalance, setShowBalance] = useState(false);
  const [loading, setLoading] = useState(true);

  const closeModal = (e) => {
    e.stopPropagation();
    setMessage("");
    setShowModal(false);
  };

  const handleLinkClick = (e) => {
    e.preventDefault();
    const action = e.target.innerText;
    setMessage(t("dashboard.debit_card.coming_soon_action", { action }));
  };

  const toggleBalanceVisibility = () => {
    setShowBalance(!showBalance);
  };

  useEffect(() => {
    const fetchCardBalance = async () => {
      if (propCardBalance !== undefined) {
        // Ensure numeric value
        const numericBalance = Number(propCardBalance) || 0;
        setCardBalance(numericBalance);
        setLoading(false);
        return;
      }

      if (cardId) {
        try {
          setLoading(true);

          const response = await getRequest(`/api/v1/cards/details/${cardId}/`);
          const numericBalance = Number(response?.balance) || 0;
          setCardBalance(numericBalance);
        } catch (error) {
          console.error("Error fetching card balance:", error);
          setCardBalance(0);
        } finally {
          setLoading(false);
        }
      } else {
        setCardBalance(0);
        setLoading(false);
      }
    };

    fetchCardBalance();
  }, [cardId, propCardBalance]);

  return (
    <div className="debit-card-container kai-os-hide">
      <div className="debit-card-wrapper">
        <Cards number="" expiry="" cvc="" name="" focused="" issuer="visa" />

        {/* Custom overlay for balance and name */}
        <div className="card-overlay">
          <div className="card-name">{currentUser || "BANANACRYSTAL"}</div>
          <div className="card-balance-container">
            <div className="card-balance-label">{t("dashboard.debit_card.balance")}</div>
            <div className="card-balance-amount">
              {loading ? (
                <span className="loading-placeholder">{t("dashboard.common.loading")}</span>
              ) : showBalance ? (
                `$${cardBalance.toFixed(2)}`
              ) : (
                "$ •••••••"
              )}
              <button
                className="toggle-balance-btn"
                onClick={(e) => {
                  e.stopPropagation(); // Prevent card click event
                  toggleBalanceVisibility();
                }}
                aria-label={
                  showBalance
                    ? t("dashboard.common.hide_balance")
                    : t("dashboard.common.show_balance")
                }
              >
                {showBalance ? <HideIcon /> : <ShowIconEye />}
              </button>
            </div>
          </div>

          {/* Custom Visa logo */}
          <div className="card-issuer-logo">VISA</div>
        </div>
      </div>

      {showModal && (
        <div className="cmodal fade show" tabIndex="-1" aria-hidden="true">
          <div className="modal-dialog modal-dialog-centered modal-dialog-scrollable">
            <div className="modal-content pl-2 pr-2">
              <div className="modal-header">
                <h5 className="modal-title">{t("dashboard.debit_card.feature_coming_soon")}</h5>
                <button type="button" className="close" onClick={closeModal}>
                  <span aria-hidden="true">&times;</span>
                </button>
              </div>
              <div className="modal-body">
                <div
                  className="mb-2"
                  style={{
                    background: "#f79237",
                    color: "white",
                    fontSize: "1rem",
                  }}
                >
                  <span>{t("dashboard.debit_card.in_development")}</span>
                </div>
                <ul>
                  <li>
                    <a href="/cards/requests/new">{t("dashboard.debit_card.apply_for_card")}</a>
                  </li>
                  <li>
                    <a href="#" onClick={handleLinkClick}>
                      {t("dashboard.debit_card.activate_card")}
                    </a>
                  </li>
                  <li>
                    <a href="#" onClick={handleLinkClick}>
                      {t("dashboard.debit_card.view_card_info")}
                    </a>
                  </li>
                </ul>
                <div>{message}</div>
              </div>
              <div className="modal-footer border-0 pl-0 pr-0">
                <button
                  type="button"
                  className="btn btn-secondary"
                  onClick={closeModal}
                >
                  {t("dashboard.common.cancel")}
                </button>
                <button
                  type="button"
                  className="btn btn-primary"
                  onClick={closeModal}
                >
                  {t("dashboard.common.ok")}
                </button>
              </div>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default DebitCard;
